import * as navigation from 'Navigation';

export default class MoleculePredictedPropertiesTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Property Prediction',
      closeable: false,
      preferenceKey: 'molecule-property-prediction',
    };
  }
}
